module.exports = __webpack_public_path__ + "731ac1650b342731a676220d4b5d3d41.obj";